import { render } from "./CustomLoader.vue?vue&type=template&id=3bbaf4dd"
import script from "./CustomLoader.vue?vue&type=script&lang=js"
export * from "./CustomLoader.vue?vue&type=script&lang=js"

import "./CustomLoader.vue?vue&type=style&index=0&id=3bbaf4dd&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__